// Tiny global toast queue.
interface Toast { id: number; msg: string; kind: 'error' | 'ok' | 'info' }

export function useToast() {
  const toasts = useState<Toast[]>('toasts', () => [])
  const seq = useState<number>('toast_seq', () => 0)

  function push(msg: string, kind: Toast['kind'] = 'info', ttl = 4000) {
    seq.value += 1
    const id = seq.value
    toasts.value = [...toasts.value, { id, msg, kind }]
    if (process.client) {
      setTimeout(() => dismiss(id), ttl)
    }
  }
  function dismiss(id: number) {
    toasts.value = toasts.value.filter(t => t.id !== id)
  }
  return {
    toasts,
    dismiss,
    push,
    // neutral alias the DFS pages call as toast.show(msg) — maps to an info
    // toast so every existing call site renders instead of throwing
    // "toast.show is not a function".
    show: (m: string, kind: Toast['kind'] = 'info') => push(m, kind),
    error: (m: string) => push(m, 'error', 5000),
    ok: (m: string) => push(m, 'ok'),
    info: (m: string) => push(m, 'info'),
  }
}
